import NavigationMenu from "../components/NavigationMenu";
import Footer from "../components/Footer";
import { Link, HeadFC } from "gatsby";

const NotFoundPage = () => {
  return (
    <>
      <main className="flex flex-col items-center justify-center min-h-screen p-6 text-gray-800">
        <NavigationMenu />
        <div className="text-center mt-20 mb-20">
          <h1 className="text-6xl font-bold text-gray-800 mb-16">404 Page Not Found</h1>
          <Link
            to="/"
            className="whitespace-nowrap fluid-base font-bold w-full rounded-3xl py-4 px-4 sm:px-8 bg-orange-500 max-w-max text-white lg:fluid-lg py-4 px-8"
          >
            Take Me Home
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFoundPage;

export const Head: HeadFC = () => <title>Page Not Found</title>;